import CreateCTAContainer from "../../../../Component/Application/CTAs/CreateCTA/CreateCTA";

const AddCTA = () => {
  return (
    <div className="page-body">
      <CreateCTAContainer />
    </div>
  );
};

export default AddCTA;
